import {useCallback} from "react"
import {useQuery, useQueryClient} from "@tanstack/react-query"
import {majorService, termsServiceV2} from "services"
import {UNLIMITED_PAGE_SIZE} from "data/constants"
import moment from "moment"

const queryCacheKey = "current-term"
const INITIAL_DATA = {
    currentTerms: [], // Terms with start_date <= now and end_date >= now
    upcomingTerms: [], // Terms with start_date > now
    activeTerms: [] // Terms with end_date >= now and enrolled programs's start_date >= now or upcomingTerm
}

export const useCurrentTerms = () => {
    const queryClient = useQueryClient()

    const query = useQuery(
        [queryCacheKey],
        async () => {
            const {data: terms} = await termsServiceV2.getAllTerms({
                sort: {
                    orderBy: "start_date",
                    orderDir: "asc"
                },
                range: {
                    page: 1,
                    pageSize: UNLIMITED_PAGE_SIZE
                },
                filter: {
                    isActive: true,
                    startDate: moment.utc().format("YYYY-MM-DD")
                }
            })
            const currentTerms = terms.filter(
                (term) =>
                    moment(term.start_date).isSameOrBefore(moment.utc()) &&
                    moment(term.end_date).isSameOrAfter(moment.utc())
            )
            const upcomingTerms = terms.filter((term) => moment(term.start_date).isSameOrAfter(moment.utc()))
            let activeTerms = currentTerms.length ? currentTerms : upcomingTerms
            if (currentTerms.length) {
                const {data: _programsOfTerm} = await majorService.getMajorByTerm(currentTerms.map((term) => term.id))
                const hasActiveProgram = _programsOfTerm.some((program) =>
                    moment(program.start_date).isSameOrAfter(moment.utc())
                )
                if (!hasActiveProgram) {
                    activeTerms = upcomingTerms
                }
            }
            return {
                currentTerms,
                upcomingTerms,
                activeTerms
            }
        },
        {
            refetchOnMount: false
        }
    )

    return {
        currentTerms: query.data?.currentTerms ?? INITIAL_DATA.currentTerms,
        upcomingTerms: query.data?.upcomingTerms ?? INITIAL_DATA.upcomingTerms,
        activeTerms: query.data?.activeTerms ?? INITIAL_DATA.activeTerms,
        invalidateTermsCache: useCallback(() => {
            queryClient.invalidateQueries({queryKey: [queryCacheKey]})
        }, [queryClient])
    }
}
